import { ActionTree } from 'vuex'

const actions: ActionTree<any, any> = {
	setCurrentStatementId({ state, commit }, payload: number) {
		commit('mutateCurrentStatementId', payload)
	},
	recordChoice({ state, commit }, payload: {id: number, choice: boolean | string}) {
		commit('mutateChoices', payload)
	},
	recordGraphSeen({ state, commit }, payload: number) {
		commit('mutateGraphSeen', payload)
	},
	recordResultsSeen({ state, commit }, payload: boolean) {
		commit('mutateResultsSeen', payload)
	},
	recordResultsSeenFirsTime({ state, commit }) {
		commit('mutateResultsSeenFirstTime', true)
	}

}

export default actions
